import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Domestic from './Domestic';
import Bound from './Bound';
import FlagsList from './FlagsList';
import axios from '../../../axios/axios';
import Loader from '../../components/loader/loader';
import { translateStaticContent } from '../../../helpers/translateStaticContent';

class Tariffs extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.state = {
            domestic: 'show',
            outBound: '',
            inBound: '',
            domesticData: [],
            inBoundData: [],
            inBoundListISO: [],
            outBoundData: [],
            outBoundListISO: [],
            id: '',
            loading: false,
            loadingInBound: false,
            loadingOutBound: false,
        }
    }

    componentDidMount() {
        if (this.props.defaultStaticContentTariffs) {
            this.getDomesticTariffs(); 
        }
        if (this.props.location.state) {
            this.handleToggleContent(null, this.props.location.state);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.activeLang !== prevProps.activeLang) {
            this.getDomesticTariffs();
            this.getInBoundData();
            this.getOutBoundData();
        }
        if (this.props.defaultStaticContentTariffs !== prevProps.defaultStaticContentTariffs &&
            this.props.defaultStaticContentTariffs) {
            this.getDomesticTariffs(); 
        }
    }

    getDomesticTariffs = () => {
        this.setState({...this.state, loading: true }, () => {
            axios.get(`/api/welsend/public/tariffs?countryIso3=ukr&direction=domestic`, {
                headers: {
                  isocode: this.props.activeLang || 'uk'
                }
              })
            .then(res => {
                this.setDomesticData(res.data);
            })
            .catch((error =>  {
                console.log(error);
            }))
        })
    }

    setDomesticData(tariffs) {
        const staticMin = translateStaticContent('tableDataMin', 
                         this.props.defaultStaticContentTariffs, this.props.activeLangStaticContentTariffs);
        const staticFrom = translateStaticContent('tableDataFrom', 
                         this.props.defaultStaticContentTariffs, this.props.activeLangStaticContentTariffs);
        const staticTo = translateStaticContent('tableDataTo', 
                         this.props.defaultStaticContentTariffs, this.props.activeLangStaticContentTariffs);
        const staticAllValues = translateStaticContent('tableDataAllValues', 
                         this.props.defaultStaticContentTariffs, this.props.activeLangStaticContentTariffs);
        const listTarrifs = tariffs.map((tariff) => {
            let commission = '';
            const commissionPercent = tariff.commissionPercent ? (tariff.commissionPercent*100).toFixed(2) : '';
            if (commissionPercent && tariff.minCommissionAmountInToCcy) {
                commission = 
                    `${commissionPercent}% ${staticMin} ${(tariff.minCommissionAmountInToCcy).toFixed(2)} ${tariff.fromCurrency}`; 
            } else if (commissionPercent && !tariff.minCommissionAmountInToCcy) {
                commission = `${commissionPercent}%`;
            } else if (!commissionPercent && tariff.minCommissionAmountInToCcy) {
                commission = `${(tariff.minCommissionAmountInToCcy).toFixed(2)} ${tariff.fromCurrency}`;
            }

            let transferAmount = '';
            if (tariff.minTransferAmount && tariff.maxTransferAmount) {
                transferAmount = `${(tariff.minTransferAmount).toFixed(2)} - ${(tariff.maxTransferAmount).toFixed(2)}`;
            } else if (tariff.minTransferAmount && !tariff.maxTransferAmount) {
                transferAmount = `${staticFrom} ${(tariff.minTransferAmount).toFixed(2)}`;
            } else if (!tariff.minTransferAmount && tariff.maxTransferAmount) {
                transferAmount = `${staticTo} ${(tariff.maxTransferAmount).toFixed(2)}`;
            } else if (!tariff.minTransferAmount && !tariff.maxTransferAmount) {
                transferAmount = staticAllValues;
            }
            return <Domestic key={tariff.id} 
                             commission={commission} 
                             transferAmount={transferAmount}
                             toCondition={tariff.toCondition}
                             fromCondition={tariff.fromCondition}
                             defaultStaticContentTariffs={this.props.defaultStaticContentTariffs}
                             activeLangStaticContentTariffs={this.props.activeLangStaticContentTariffs}
                        />
        })
        this.setState({...this.state, domesticData: listTarrifs, loading: false})
    }
    
    handleToggleContent = (e, dir) => {
        const targetContent = e ? e.target.id : dir;
        switch (targetContent) {
            case 'domestic': {
                this.setState({...this.state, domestic: 'show', outBound: '', inBound: ''});
                break;
            }
            case 'outbound': {
                this.setState({...this.state, domestic: '', outBound: 'show', inBound: '', loadingOutBound: true});
                this.getOutBoundData();
                break;
            }
            case 'inbound': {
                this.setState({...this.state, domestic: '', outBound: '', inBound: 'show', loadingInBound: true});
                this.getInBoundData();
                break;
            }
            default:
            return this.state;
        }
    }

    getInBoundData() {
        axios.defaults.headers.isocode = this.props.activeLang ? this.props.activeLang : 'uk';
        axios.get(`api/welsend/public/tariffs?countryIso3=ukr&direction=inbound`)
        .then(res => {
            this.setInBoundData(res.data);
        })
        .catch((error =>  {
            console.log(error);
        }))
    }

    getOutBoundData() {
        axios.defaults.headers.isocode = this.props.activeLang ? this.props.activeLang : 'uk';
        axios.get(`api/welsend/public/tariffs?countryIso3=ukr&direction=outbound`)
        .then(res => {
            this.setOutBoundData(res.data);
        })
        .catch((error =>  {
            console.log(error);
        }))
    }

    setInBoundData(tariffs) {
        const countries = []
        tariffs.forEach(tariff => {
            if(!countries.includes(JSON.stringify({
                countryName: tariff.fromCountryName,
                iso: tariff.fromCountryIso3,
                id: tariff.fromCountryName}))) {
                    countries.push(JSON.stringify({
                    countryName: tariff.fromCountryName,
                    iso: tariff.fromCountryIso3,
                    id: tariff.fromCountryName
                }))
            }
        })

        const parseCountries = countries.map(elem => {
            return JSON.parse(elem)});

        const flagsList = this.getFlagList(parseCountries, 'in');

        let tariffsFromCountryName = [];

        const sortList = (list) => {
            return list.sort( (a, b) => {
                if(a.partnerInfoDto === null && b.partnerInfoDto === null) {
                    if (a.toCurrency > b.toCurrency) {
                        return 1;
                    }
                    if (a.toCurrency < b.toCurrency) {
                        return -1;
                    }
                    return 0;
                } else if (a.partnerInfoDto !== null && b.partnerInfoDto !== null) {
                    if (a.partnerInfoDto.partnerName > b.partnerInfoDto.partnerName) {
                        return 1;
                    }
                    if (a.partnerInfoDto.partnerName < b.partnerInfoDto.partnerName) {
                        return -1;
                    }
                    if (a.partnerInfoDto.partnerName === b.partnerInfoDto.partnerName) {
                        if (a.toCurrency > b.toCurrency) {
                            return 1;
                        }
                        if (a.toCurrency < b.toCurrency) {
                            return -1;
                        }
                        if (a.toCurrency === b.toCurrency) {
                            return a.minTransferAmount - b.minTransferAmount
                        }
                    }
                }
            })
        }
        
        const groupByPartnerInfoDto = (list) => {
            return list.reduce((groups, tariff, index, arr) => {
                const key = tariff.partnerInfoDto ? tariff.partnerInfoDto.partnerName : 'null';
                 if (!groups[key]) {
                    groups[key] = [];
                }
                groups[key].push(tariff);
                return arr.length === index + 1 ? Object.values(groups) : groups;
            }, {})
        }

        tariffs.forEach(tariff => {
            const fromCountryName = tariff.fromCountryName

            const listOfTariffsFromISO = tariffs.filter(iso => iso.fromCountryName === fromCountryName)

            const listOfTariffs = {
                fromCountryName: listOfTariffsFromISO[0].fromCountryName,
                fromCountryIso3: listOfTariffsFromISO[0].fromCountryIso3,
                id: listOfTariffsFromISO[0].id,
                list: groupByPartnerInfoDto(sortList(listOfTariffsFromISO))
            }
            
            if (!tariffsFromCountryName.some(tariff => tariff.fromCountryName === fromCountryName)) {
                tariffsFromCountryName = [...tariffsFromCountryName, {...listOfTariffs}];
            } 
        })
        const listInBoundTarrifs = tariffsFromCountryName.map(tariff => {
            return <Bound   countryName={tariff.fromCountryName}
                            countryIso3={tariff.fromCountryIso3}
                            key={tariff.id}
                            direction={'in'}
                            id={tariff.id}
                            list={tariff.list} 
                            defaultStaticContentTariffs={this.props.defaultStaticContentTariffs}
                            activeLangStaticContentTariffs={this.props.activeLangStaticContentTariffs}/>
        })
        this.setState({...this.state, inBoundData: listInBoundTarrifs, 
                        inBoundListISO: flagsList, loadingInBound: false});
    }

    setOutBoundData(tariffs) {
        const countries = []
        tariffs.forEach(tariff => {
            if(!countries.includes(JSON.stringify({
                countryName: tariff.toCountryName,
                iso: tariff.toCountryIso3,
                id: tariff.toCountryName}))) {
                    countries.push(JSON.stringify({
                    countryName: tariff.toCountryName,
                    iso: tariff.toCountryIso3,
                    id: tariff.toCountryName
                }))
            }
        })

        const parseCountries = countries.map(elem => {
            return JSON.parse(elem)});

        const flagsList = this.getFlagList(parseCountries, 'out');
    
        let tariffsToCountryName = [];


        const sortList = (list) => {
            return list.sort( (a, b) => {
                if(a.partnerInfoDto === null && b.partnerInfoDto === null) {
                    if (a.toCurrency > b.toCurrency) {
                        return 1;
                    }
                    if (a.toCurrency < b.toCurrency) {
                        return -1;
                    }
                    return 0;
                } else if (a.partnerInfoDto !== null && b.partnerInfoDto !== null) {
                    if (a.partnerInfoDto.partnerName > b.partnerInfoDto.partnerName) {
                        return 1;
                    }
                    if (a.partnerInfoDto.partnerName < b.partnerInfoDto.partnerName) {
                        return -1;
                    }
                    if (a.partnerInfoDto.partnerName === b.partnerInfoDto.partnerName) {
                        if (a.toCurrency > b.toCurrency) {
                            return 1;
                        }
                        if (a.toCurrency < b.toCurrency) {
                            return -1;
                        }
                        if (a.toCurrency === b.toCurrency) {
                            return a.minTransferAmount - b.minTransferAmount
                        }
                    }
                }
            })
        }
        
        const groupByPartnerInfoDto = (list) => {
            return list.reduce((groups, tariff, index, arr) => {
                const key = tariff.partnerInfoDto ? tariff.partnerInfoDto.partnerName : 'null';
                 if (!groups[key]) {
                    groups[key] = [];
                }
                groups[key].push(tariff);
                return arr.length === index + 1 ? Object.values(groups) : groups;
            }, {})
        }

        tariffs.forEach(tariff => {
            const toCountryName = tariff.toCountryName

            const listOfTariffsToISO = tariffs.filter(iso => iso.toCountryName === toCountryName)

            const listOfTariffs = {
                toCountryName: listOfTariffsToISO[0].toCountryName,
                toCountryIso3: listOfTariffsToISO[0].toCountryIso3,
                id: listOfTariffsToISO[0].id,
                list: groupByPartnerInfoDto(sortList(listOfTariffsToISO))
            }
            
            if (!tariffsToCountryName.some(tariff => tariff.toCountryName === toCountryName)) {
                tariffsToCountryName = [...tariffsToCountryName, {...listOfTariffs}];
            } 
        })
        const listOutBoundTarrifs = tariffsToCountryName.map(tariff => {
            return <Bound   countryName={tariff.toCountryName}
                            countryIso3={tariff.toCountryIso3}
                            key={tariff.id}
                            id={tariff.id}
                            direction={'out'}
                            list={tariff.list} 
                            defaultStaticContentTariffs={this.props.defaultStaticContentTariffs}
                            activeLangStaticContentTariffs={this.props.activeLangStaticContentTariffs}/>
        })
        this.setState({...this.state, outBoundData: listOutBoundTarrifs, 
                        outBoundListISO: flagsList, loadingOutBound: false}); 
    }

    handleScrollToTariff = (e)  => {
       const linkID = e.currentTarget.id;
       const targetID = linkID.slice(1);
       const target = document.getElementById(targetID);
       
        setTimeout(function () {
            window.scrollTo(0, target.offsetTop +  target.offsetParent.offsetTop);
        }, 2);  
    }

    getFlagList(countries, direction) {
        const listOfISO = countries.map((country, i) => {
            return <FlagsList countryName={country.countryName} 
                              iso={country.iso} 
                              key={i} 
                              scrollToTariff={this.handleScrollToTariff}
                              direction={direction}
                              id={country.id} />
        })
        return listOfISO;
    }

    render() {
        return(
            <div className="container tariffs">
                <h1>
                    {translateStaticContent('tariffsHeading', 
                        this.props.defaultStaticContentTariffs, this.props.activeLangStaticContentTariffs)}
                </h1>
                    <div className="content">
                        <ul className='nav'>
                            <li onClick={this.handleToggleContent} 
                                        id='domestic' 
                                        className={this.state.domestic ? 'active' : ''}>
                                {translateStaticContent('tariffsDomestic', 
                                    this.props.defaultStaticContentTariffs, this.props.activeLangStaticContentTariffs)}
                            </li>
                            <li onClick={this.handleToggleContent} 
                                        id='outbound' 
                                        className={this.state.outBound ? 'active' : ''}>
                                {translateStaticContent('tariffsOutbound', 
                                    this.props.defaultStaticContentTariffs, this.props.activeLangStaticContentTariffs)}
                            </li>
                            <li onClick={this.handleToggleContent} 
                                        id='inbound' 
                                        className={this.state.inBound ? 'active' : ''}>
                                {translateStaticContent('tariffsInbound', 
                                    this.props.defaultStaticContentTariffs, this.props.activeLangStaticContentTariffs)}
                            </li>
                        </ul>
                        <div className={`domestic ${this.state.domestic}`}>
                            {this.state.domesticData.length > 0 ? 
                                <h2>
                                    {translateStaticContent('tariffsDomesticHeading', 
                                         this.props.defaultStaticContentTariffs, this.props.activeLangStaticContentTariffs)}
                                </h2> : ''}
                                {this.state.loading ? <Loader /> :  
                                    <div>
                                     {this.state.domesticData.length > 0 ? this.state.domesticData : ''}
                                    </div> 
                                }
                        </div>
                        <div className={`outbound ${this.state.outBound}`}>
                            {this.state.loadingOutBound ? <Loader /> : <div>
                                {this.state.outBoundData.length > 0 ? 
                                    <h2>
                                        {translateStaticContent('tariffsOutboundHeading', 
                                            this.props.defaultStaticContentTariffs, 
                                            this.props.activeLangStaticContentTariffs)}
                                </h2> : ''}
                                <div className='flags'>
                                    {this.state.outBoundListISO.length > 0 ? this.state.outBoundListISO : ''}
                                </div>
                                {this.state.outBoundData.length > 0 ? this.state.outBoundData : ''}
                            </div>
                            }
                        </div>
                        <div className={`inbound ${this.state.inBound}`}>
                            {this.state.loadingInBound ? <Loader /> : 
                            <div>
                                {this.state.inBoundData.length > 0 ? 
                                    <h2>
                                        {translateStaticContent('tariffsInboundHeading', 
                                            this.props.defaultStaticContentTariffs, 
                                            this.props.activeLangStaticContentTariffs)}
                                    </h2> : ''}
                                <div className='flags'>
                                    {this.state.inBoundListISO.length > 0 ? this.state.inBoundListISO : ''}
                                </div>
                                {this.state.inBoundData.length > 0 ? this.state.inBoundData : ''}
                            </div>
                            }
                        </div>
                    </div>
            </div>
        )
    }
    
}

const mapStateToProps = state => ({
    activeLang: state.lang.activeLang
})

export default connect(mapStateToProps)(Tariffs);
  
Tariffs.propTypes = {
    activeLang: PropTypes.string.isRequired,
    defaultStaticContentTariffs: PropTypes.object,
    activeLangStaticContentTariffs: PropTypes.object,
    location: PropTypes.object,
}
